import {AnimatedEmoji} from '@remotion/animated-emoji';

export const UseanimatedEmojis: React.FC = () => {
	return <AnimatedEmoji emoji="blush" />;
};
